module.exports = __webpack_public_path__ + "img/collectiongallery_naturalbeige.b6f0eba.jpg";